export const PortOfEntryInput = [
    {name:'Visakhapatnam',value:1},{name : 'Kakinada',value:2}
]
  

